import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as ds from './dashboardSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { getDailyStatistics, getMonthlyReceipts, getMonthlyTransactions, getMonthlyRevenue } from './dashboardAPI';

//======================== watchers =============================================


export function* onLoadDailyStatisticsStartAsync(){

    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.dailyStatisticsLoading }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };
        
        const response = yield call(getDailyStatistics, reqBody);
        
        if(response.status === 200){
            
            let dailyStats = response.data;
            
            yield put(ds.actions.dailyStatsFetched({ dailyStats }));

        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }
                
            let errorMsg = "There was an error retrieving the daily statistics data.";

            // yield put(uis.actions.showNotification({
            //     status: "error",
            //     title: "Error",
            //     message: errorMsg
            // }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.dailyStatisticsLoading,
                error: errorMsg
            }));
        }
    }
};

export function* onLoadMonthlyTransactionsStartAsync() {
    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.monthlyTransactionsLoading }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getMonthlyTransactions, reqBody);        

        if(response.status === 200){
            let monthlyTrans = response.data;
            yield put(ds.actions.monthlyTransFetched({ monthlyTrans }));
        }

    }
    catch (error){

        console.log(error);
        
        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));

            }
                
            let errorMsg = "There was an error retrieving the monthly revenue data.";

            // yield put(uis.actions.showNotification({
            //     status: "error",
            //     title: "Error",
            //     message: errorMsg
            // }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.monthlyTransactionsLoading,
                error: errorMsg
            }));
        }
    }
};

export function* onLoadMonthlyRevenueStartAsync() {
    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.monthlyRevenueLoading }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getMonthlyRevenue, reqBody);        

        if(response.status === 200){
            let monthlyRev = response.data;
            yield put(ds.actions.monthlyRevFetched({ monthlyRev }));
        }

    }
    catch (error){

        console.log(error);

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }

            let errorMsg = "There was an error retrieving the monthly revenues."

            // yield put(uis.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.monthlyRevenueLoading,
                error: errorMsg
            }));
        }
    }
};

export function* onLoadMonthlyReceiptsStartAsync() {
    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.monthlyReceiptsLoading }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getMonthlyReceipts, reqBody);        

        if(response.status === 200){
            let monthlyRec = response.data;
            yield put(ds.actions.monthlyRecFetched({ monthlyRec }));
        }

    }
    catch (error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }
            
            let errorMsg = "There was an error retrieving the monthly receipts."

            // yield put(uis.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.monthlyReceiptsLoading,
                error: errorMsg
            }));
        }
    }
};

export const actionTypes = {
    FetchDailyStats: "[DailyStatsFetched] Fetch Dashboard Date API Action",
    FetchMonthlyTrans: "[MonthlyTransUpdate] Fetch Monthly Transaction API Action",
    FetchMonthlyRevenue: "[MonthlyRevenueFetched] Fetch Monthly Revenue API Action",
    FetchMonthlyReceipts: "[MonthlyReceiptsFetched] Fetch Monthly Receipts API Action",
};

export const actions = {

    fetchDailyStats: () => ({ type: actionTypes.FetchDailyStats, payload: { undefined }}),
    fetchMonthlyTrans: () => ({ type: actionTypes.FetchMonthlyTrans, payload: { undefined } }),
    fetchMonthlyRevenue: () => ({ type: actionTypes.FetchMonthlyRevenue, payload: { undefined }}),
    fetchMonthlyReceipts: () => ({ type: actionTypes.FetchMonthlyReceipts, payload: { undefined } })
};

//======================== workers =============================================

export function* fetchDailyStats() {
    
    yield takeEvery(actionTypes.FetchDailyStats, onLoadDailyStatisticsStartAsync);
};

export function* fetchMonthlyTrans() {

    yield takeEvery(actionTypes.FetchMonthlyTrans, onLoadMonthlyTransactionsStartAsync);
};

export function* fetchMonthlyRevenue() {

    yield takeEvery(actionTypes.FetchMonthlyRevenue, onLoadMonthlyRevenueStartAsync);
};

export function* fetchMonthlyReceipts() {

    yield takeEvery(actionTypes.FetchMonthlyReceipts, onLoadMonthlyReceiptsStartAsync);
};

const dsSagas = [
    fork(fetchDailyStats),
    fork(fetchMonthlyTrans),
    fork(fetchMonthlyRevenue),
    fork(fetchMonthlyReceipts)
];

export function* saga(){
    yield all([...dsSagas]);
};